import {
  RENTAL_PORTAL_MOCK_AVATAR_COLORS,
  RENTAL_PORTAL_MOCK_MEDIA_URL_BY_PATH,
} from '../constants/rentalPortalMockMedia'

export function getRentalPortalMockMediaUrl(mediaPath) {
  return RENTAL_PORTAL_MOCK_MEDIA_URL_BY_PATH.get(mediaPath) ?? null
}

export function toRentalPortalMockMediaPhoto(photo) {
  return photo
    ? {
        ...photo,
        thumb_url: getRentalPortalMockMediaUrl(photo.thumb_url),
        url: getRentalPortalMockMediaUrl(photo.url),
      }
    : null
}

export function toRentalPortalMockMediaUser(user) {
  return user
    ? {
        ...user,
        avatar_thumb_url: getRentalPortalMockMediaUrl(user.avatar_thumb_url),
        avatar_url: getRentalPortalMockMediaUrl(user.avatar_url),
      }
    : null
}

export function getRentalPortalMockAvatarColor(id) {
  return id == null
    ? null
    : RENTAL_PORTAL_MOCK_AVATAR_COLORS[
        Number(id) % RENTAL_PORTAL_MOCK_AVATAR_COLORS.length
      ]
}
